import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

interface Report {
  ReportId: string;
  WorkspaceId: string;
  Name: string;
  Description: string;
  EmbedUrl: string;
  DatasetId: string;
  IsActive: boolean;
  CreatedDtm: string;
  UpdatedDtm: string;
  CreatedUser: string;
  UpdatedUser: string;
}

interface ReportListState {
  isLoading: boolean;
  data: {
    Code: number;
    Status: string;
    Message: string;
    Data: Report[];
  } | null;
  error: string | null;
}

const initialState: ReportListState = {
  isLoading: true,
  data: null,
  error: null,
};

export const fetchReportListData = createAsyncThunk(
  "CTReportListSlice/fetchReportListData",
  async (_, thunkApi) => {
    try {
      const response = await httpClient.post("/report", {
        Action: "retrieveallreports",
      });

      if (response.status != 200 || response.data.Status !== "success") {
        if (response.data.Status == "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        } else {
          return thunkApi.rejectWithValue({
            message: "Failed to get report list",
          });
        }
      }
      return response.data;
    } catch (error: any) {
      console.log("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({
        message: "Failed to get report list",
      });
    }
  },
);

const CTReportListSlice = createSlice({
  name: "CTReportListSlice",
  initialState,
  reducers: {
    resetReportState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReportListData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(
        fetchReportListData.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action.payload.Status == "success") {
            state.isLoading = false;
            state.data = action.payload;
            state.error = null;
          } else if (action.payload.Status == "error") {
            state.isLoading = false;
            state.data = null;
            state.error = action.payload.message;
          }
        },
      )
      .addCase(
        fetchReportListData.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = null;
          state.error = action.payload.message;
        },
      );
  },
});

export const { resetReportState } = CTReportListSlice.actions;

export default CTReportListSlice.reducer;
